<template>
  <div class="calendar-layout">
    <default-box
      v-if="holiday_dates.length"
      class="mb-3">
      <ValidationObserver v-slot="{ invalid, passes }" ref="form">
      <default-form @submit.prevent="passes(saveHolidays)">
        <div class="row row-gap-15">
          <div
            class="col-md-4 col-6"
            v-for="holiday_date in holiday_dates">
            <default-input
              :label="$t('vacations.description_for') + ' ' + holiday_date.date"
              :placeholder="$t('vacations.date_description')"
              v-model="holiday_date.title"
              required
            />
          </div>
          <div class="col-12">
            <default-button>{{ $t('inputs.save') }}</default-button>
          </div>
        </div>
      </default-form>
      </ValidationObserver>
      <loader v-if="loading"/>
    </default-box>
    <default-box>
      <calendar
        is_multiple_choice
        show_two_in_column
        :calendar_title="$t('vacations.holidays_calendar')"
        :selected_dates="get_selected_dates"
        :background_texts_by_date="texts_by_date"
        @selectedDays="selectedDays"
        :calendar_date_outer.sync="current_year"
        @yearChange="yearChange"
      />
      <loader v-if="loading"/>
    </default-box>
  </div>
</template>

<script>

import Calendar from "../small_components/calendar/Calendar";
import DefaultBox from "../slots/DefaultBox";
import {unlinkVueVariable} from "../../helpers/global_vars";
import DefaultForm from "../small_components/form-parts/DefaultForm";
import DefaultInput from "../small_components/DefaultInput";
import DefaultButton from "../small_components/DefaultButton";
import {axiosPublicHoliday} from "../../helpers/axios_requests";
import Loader from "../small_components/Loader";
import {getDateFormatShortDateStr} from "../../mixins/dateMixin";
import {FORMAT_ERROR_MESSAGE} from "../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../store/modules/notifiocation";
import {ValidationObserver} from "vee-validate";
import {mapActions} from "vuex";

export default {
  name: 'HolidayCalendarLayout',
  components: {
    Loader,
    DefaultButton,
    DefaultInput,
    DefaultForm,
    DefaultBox,
    Calendar,
    ValidationObserver
  },
  computed: {
    get_selected_dates() {
      return this.holiday_dates.map(el => {
        return el.date
      })
    },
    texts_by_date() {
      let data = {}
      this.holiday_dates.forEach(el => {
        data[el.date] = el.title
      })
      return data
    }
  },
  mounted() {
    this.fetchList()
  },
  data() {
    return {
      loading: false,
      current_year: (new Date).getFullYear(),
      holiday_dates: []
    }
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    fetchList() {
      this.loading = true
      axiosPublicHoliday.fetchList({year: this.current_year})
        .then(({data}) => {
          this.holiday_dates = data.map(el => {
            el.date = getDateFormatShortDateStr(new Date(el.date))
            return el
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    yearChange() {
      this.fetchList()
    },
    saveHolidays() {
      axiosPublicHoliday.createUpdate({holiday_dates: this.holiday_dates})
        .then(r => {
          if (r.data.errors) {
            this.$refs.form.setErrors(r.data.errors);
            let message = FORMAT_ERROR_MESSAGE(r.data.errors)
            this.actionPushNotification(
                {message: message, status: STATUS_ERROR}
            );
          }
          this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
        })
    },
    selectedDays({dates}) {
      let holiday_dates = dates.map(date => {
        if (!this.get_selected_dates.includes(date)) {
          return {
            id: 0,
            date: date,
            title: ''
          }
        }
        return this.holiday_dates.find(holiday_date => holiday_date.date === date)
      }).filter(Boolean)
      this.$set(this, 'holiday_dates', unlinkVueVariable(holiday_dates))
    }
  }
}
</script>
